import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from 'components/common/Loader';
import { selectIsAuthenticated, selectIsRestoring } from 'features/auth/authSelectors';
import { ROUTES } from 'constants/routes';

/** Public-only routes (e.g. login). Authenticated users are sent to the app. */
const PublicRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isRestoring = useSelector(selectIsRestoring);

  if (isRestoring) return <Loader fullscreen label="Loading…" />;
  if (isAuthenticated) return <Navigate to={ROUTES.DASHBOARD} replace />;

  return <Outlet />;
};

export default PublicRoute;
